import React from "react";
import { User } from "react-feather";
import { image } from "../../helpers";
import cn from "classnames";

class Creators extends React.Component {
  render() {
    const { className } = this.props;

    return (
      <React.Fragment>
        {this.props.created_by &&
          this.props.created_by.length > 0 && (
            <div
              className={cn(
                "shadow rounded self-center border-b-2 py-2 mb-4",
                className
              )}
            >
              <div className="p-2 text-xl text-center cursor-default">
                Creator{this.props.created_by.length > 1 && "s"}
              </div>

              {this.props.created_by.map(creator => {
                return (
                  <a
                    className="flex no-underline rounded border text-black hover:text-blue border-grey-lighter shadow hover:shadow-md transition m-3 py-2 px-6 items-center"
                    href={`/person/${creator.id}`}
                    key={creator.id}
                  >
                    <span className="w-10 h-10 mr-4">
                      {creator.profile_path ? (
                        <img
                          className="rounded-full"
                          src={image({
                            image: creator,
                            w: 64,
                            h: 64,
                            type: "person"
                          })}
                          alt={creator.name}
                        />
                      ) : (
                        <User className="m-2" />
                      )}
                    </span>

                    <div className="text-sm">
                      <p className="leading-none">{creator.name}</p>
                    </div>
                  </a>
                );
              })}
            </div>
          )}
      </React.Fragment>
    );
  }
}

export default Creators;



// WEBPACK FOOTER //
// ./src/components/Media/Creators.js